module.exports = __webpack_public_path__ + "img/图书.a3f4bbe7.png";